<template>
     <div class="limiter">
    <div class="container-login">
      <div class="wrap-login">
        <div class="login-form validate-form">
          <img src="@/assets/img/logo-grande.jpg" alt="Portal do Desenvolvedor — CEPE" class="img-logo flex-c-m"/>
          <section>
            <form v-if="!recuperarSenha" @submit.prevent="login">
                <div style="text-align: center; margin-bottom: 20px; margin-top: 20px;">
                  <label>Conecte-se</label>
                </div>
                <div class="input-container">
                  <i class="fa fa-envelope icon"></i>
                  <input
                    v-model="email"
                    @keydown.enter.prevent="$refs.inputPassword.focus()"
                    type="email"
                    autocomplete="email"
                    placeholder="Email"
                    id="inputEmail"
                    class="input-field" />
                </div>
                <div class="input-container">
                  <i class="fa fa-key icon"></i>
                  <input
                    v-model="password"
                    type="password"
                    autocomplete="current-password"
                    id="inputPassword"
                    ref="inputPassword"
                    placeholder="Senha"
                    class="input-field" />
                </div>
                <button class="btn btn-primary btn-block" type="submit" v-if="!loading">
                  Entrar
                </button>
                <button class="btn btn-primary btn-block" type="button" v-else disabled>
                  <b-spinner small type="grow"></b-spinner>
                  Entrando
                </button>
                <a href="#" class="anchor" @click.prevent="resetPassword">Esqueceu a senha?</a>
            </form>
            <form v-else @submit.prevent="confirmResetPassword">
                <div style="text-align: center; margin-bottom: 20px; margin-top: 20px;">
                  <label>Esqueceu a senha?</label>
                </div>
                <div class="input-container">
                  <i class="fa fa-envelope icon"></i>
                  <input v-model="email" type="email" autocomplete="email" placeholder="Email" class="input-field" />
                </div>
                <div class="btn-row">
                    <button class="btn btn-secondary" type="button" @click="recuperarSenha = false">
                        Cancelar
                    </button>
                    <button class="btn btn-primary" type="submit">
                        Redefinir
                    </button>
                </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/login.css">
</style>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>
  .btn-padding{
    padding: .375rem .75rem;
  }
</style>

<script>
import axios from 'axios';
import config from '../helpers/generalConfig';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  data() {
    return {
      recuperarSenha: false,
      email: '',
      password: '',
      loading: false
    };
  },
  created() {
    this.$session.destroy();
    window.document.title = 'Portal do Desenvolvedor';
    this.logout(false);
    if(this.$route.params.message){
      this.$bvToast.toast(
        this.$route.params.message,
        this.$route.params.body
      );
    }
  },
  methods: {
    isValidEmail(email) {
      return EMAIL_REGEX.test(email);
    },
    resetPassword() {
      this.recuperarSenha = true;
    },
    confirmResetPassword() {
      if (this.email && this.isValidEmail(this.email)) {
        axios
          .post(
            `${config.jsonServer}/user/sendEmailForgetPassword`,
            { email_usuario: this.email, callbackURL: location.origin+'/resetPassword/' })
          .then(() => {
            this.$bvToast.toast('Foi enviado um e-mail para você com instruções para mudar a senha.', {
              title: 'Email enviado',
              variant: 'success',
              solid: true
            });
          })
          .catch((err) => {
            if(err.response){
              this.$bvToast.toast('Verifique o email cadastrado e tente novamente após 2 minutos, ou entre em contato com um administrador', {
                title: 'Erro ao enviar email',
                variant: 'danger',
                solid: true
              });
            } else {
              this.$bvToast.toast("Sem resposta do servidor", {
                title: 'Erro ao enviar email',
                variant: 'danger',
                solid: true
              });
            }
          });
      } else {
        this.$bvToast.toast('Informe um email válido.', {
          title: 'Email inválido',
          variant: 'danger',
          solid: true
        });
      }
    },
    login() {
      if (!this.email || !this.isValidEmail(this.email)) {
        this.$bvToast.toast('Informe um email válido.', {
          title: 'Email inválido',
          variant: 'danger',
          solid: true
        });
        return;
      }
      if (!this.password) {
        this.$bvToast.toast('O campo senha não pode ser vazio.', {
          title: 'Senha inválida',
          variant: 'danger',
          solid: true
        });
        return;
      }
      this.loading = true;
      axios
        .post(`${config.jsonServer}/user/signin`, {
          email: this.email,
          password: this.password
        })
        .then(response => {
          this.$bvToast.toast('Login realizado com sucesso', {
            title: 'Login válido',
            variant: 'success',
            solid: true
          });
          const user = response.data;
          user.Email = user.email_usuario;
          this.$store.dispatch('auth/setUser', user);
          this.$store.dispatch('auth/setToken', {
            token:user.token_usuario, exp:user.exp_time
          });
          this.$router.push({ name: 'home' });
          const expires = this.$store.getters['auth/token'].expires;
          setTimeout(()=>{
            this.$router.push({ name: 'login', params: {
              message: "Conecte-se novamente",
              body: {
                title: "Sessão expirada",
                variant: "danger",
                solid: true,
              }
            }});
          }, new Date(expires*1000) - new Date());
          this.loading = false;
        })
        .catch((err) => {
          if(err.response){
            this.$bvToast.toast(err.response.data.message, {
              title: 'Erro ao realizar o login',
              variant: 'danger',
              solid: true
            });
          } else {
            this.$bvToast.toast('Sem resposta do servidor', {
              title: 'Erro ao realizar o login',
              variant: 'danger',
              solid: true
            });
          }
          this.loading = false;
        });
    },
    logout(redirect = true) {
      this.$store.dispatch('auth/setUser', undefined);
      this.$store.dispatch('auth/setToken', undefined);
      if (redirect) {
        this.$router.push({ name: 'login' });
      }
    },
  }
};
</script>
